const stationsForm = {
  bindings: {
    selection: '<',
    stations: '<',
    onFormSubmit: '&',
    isLocked: '<',
    hasEdit: '<',
  },
  templateUrl: '/modules/pis-tool/stations/stations-form/stations-form.html',
  controller: 'StationsFormController',
};

angular
  .module('pis-tool.module')
  .component('stationsForm', stationsForm)
  .config(function ($stateProvider) {
    $stateProvider.state('pis.workspaces.stations.station', {
      url: '/:id',
      views: {
        'stationsview@pis.workspaces.stations': 'stationsForm',
      },
    });
  });
